import { nanoid } from 'nanoid'

export class Device {
  private static _key = 'deviceId'

  public static set(id: string) {
    localStorage.setItem(this._key, id)
  }

  public static get() {
    return localStorage.getItem(this._key)
  }

  public static create() {
    const id = nanoid()
    this.set(id)
    return id
  }

  public static getOrCreate() {
    return this.get() || this.create()
  }
}
